module.exports = __webpack_public_path__ + "static/img/anbang-2.5f983cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/anbang-2.png
// module id = 157
// module chunks = 1